import { LinearProgress } from 'src/componentes/LinearProgress';

const SlashScreen = () => {
  return (
    <div className="loading-screen loading-screen--fixed">
      <div style={{ width: 400 }}>
        <LinearProgress />
      </div>
    </div>
  );
};

export default SlashScreen;
